import React, { Component } from 'react';
import PropTypes from 'prop-types';

//If changes to target emails are made change here
const SALES_IFV_EMAIL = 'sbcatapang@medicardphils.com';
const SALES_KABAYAN_EMAIL = 'lbatistis@medicardphils.com';
const SALES_SELECT_EMAIL = 'jmgilvero@medicardphils.com';
export default class SpeakWithAgentButton extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        targetAddress: '',
        ACDSkill:'',
        subject:'',
        targetEmail:'',
      };
    }
  
    componentDidMount() {
      //step = last action taken, steps = all actions taken
      const { step } = this.props;
      //Get which button was clicked in order to know inquiry subject, where to queue ,and what skills are needed in genesys
      if(step.id === "Individual_and_Family_Button"){
        this.setState({ subject: "Individual and Family", targetEmail: SALES_IFV_EMAIL ,targetAddress: "Sales", ACDSkill:"IFV"})
      }else if(step.id === "VIP_Button"){
        this.setState({ subject: 'VIP', targetEmail: SALES_IFV_EMAIL, targetAddress: "Sales", ACDSkill:"IFV" })
      }else if(step.id === "RxER_Button"){
        this.setState({ subject: 'RxER', targetEmail: SALES_IFV_EMAIL, targetAddress: "Sales", ACDSkill:"IFV" })
      }else if(step.id === "Health_Plus_Button"){
        this.setState({ subject: 'Health Plus', targetEmail: SALES_IFV_EMAIL, targetAddress: "Sales", ACDSkill:"IFV" })
      }else if(step.id === "Medicard_Kabayan_Button"){
        this.setState({ subject: 'Medicard Kabayan', targetEmail: SALES_KABAYAN_EMAIL, targetAddress: "Sales", ACDSkill:"OFW" })
      }else if(step.id === "Medicard_Select_Button"){
        this.setState({ subject: 'Medicard Select', targetEmail: SALES_SELECT_EMAIL, targetAddress: "Sales", ACDSkill:"IFV" })
      }else if(step.id === "Corporate_and_SME_Plans_Button"){
        this.setState({ subject: 'Corporate and SME Plans', targetAddress: "Sales", ACDSkill: "MC" })
      }else if(step.id === "Sponsorship_Button"){
        this.setState({ subject:'Sponsorship', targetAddress: "Marketing", ACDSkill: "" })
      }else if(step.id === "Corporate_Partnership_Button"){
        this.setState({ subject:'Corporate Partnership', targetAddress: "Marketing", ACDSkill: "" })
      }else if(step.id === "Promos_Button"){
        this.setState({ subject:'Promos', targetAddress: "Marketing", ACDSkill: "" })
      }else if(step.id === "Events_Button"){
        this.setState({ subject:'Events', targetAddress: "Marketing", ACDSkill: "" })
      }else if(step.id === "Request_approval_for_Laboratory_Diagnostic_test_Button"){
        this.setState({ subject:'Request approval for Laboratory/Diagnostic test', targetAddress: "CMG_BackOffice", ACDSkill: "" })
      }else if(step.id === "Request_approval_for_Consultation_Button"){
        this.setState({ subject:'Request approval for Consultation', targetAddress: "CMG_BackOffice", ACDSkill: "" })
      }else if(step.id === "Membership_coverage_Button"){
        this.setState({ subject:'Membership coverage', targetAddress: "CMG_BackOffice", ACDSkill: "" })
      }else if(step.id === "Membership_information_and_utilization_Button"){
        this.setState({ subject:'Membership information and utilization', targetAddress: "CMG_BackOffice", ACDSkill: "" })
      }else if(step.id === "Online_Consultation_Button"){
        this.setState({ subject:'Online Consultation', targetAddress: "CMG_BackOffice", ACDSkill: "" })
      }else if(step.id === "Medicard_Number_Inquiry_Button"){
        this.setState({ subject:'Medicard Number Inquiry', targetAddress: "CMG_BackOffice", ACDSkill: "" })
      }else if(step.id === "Inpatient_Inquiry_and_concerns_Button"){
        this.setState({ subject:'Inpatient Inquiry and concerns', targetAddress: "Inpatient_Approval", ACDSkill: "" })
      }else if(step.id === "Dental_Coverage_and_Concern_Button"){
        this.setState({ subject:'Dental Coverage and Concern', targetAddress: "CMG_BackOffice", ACDSkill: "" })
      }else if(step.id === "Sponsorships_Button"){
        this.setState({ subject:'Sponsorships', targetAddress: "Marketing", ACDSkill: "" })
      }else if(step.id === "Partnerships_Button"){
        this.setState({ subject:'Partnerships', targetAddress: "Marketing", ACDSkill: "" })
      }
    }
    
    getAdvancedConfig() {
      //Queue Data for Genesys Cloud 
      const { 
        targetAddress,
        ACDSkill,
        subject,
        targetEmail,
      } = this.state;

      //Assign queue route
      window._genesys.widgets.webchat.transport.interactionData.routing.targetAddress = targetAddress;
      //Assign target agent
      window._genesys.widgets.webchat.transport.interactionData.routing.agentEmail = targetEmail;
      //Assign user data to be sent to genesys
      window._genesys.widgets.webchat.userData["queueName"] = targetAddress
      window._genesys.widgets.webchat.userData["ACDSkill"] = ACDSkill
      window._genesys.widgets.webchat.userData["subject"] = subject
        
      if(ACDSkill !== '' ) window._genesys.widgets.webchat.transport.interactionData.routing.skills.push(ACDSkill);
      window._genesys.widgets.webchat.transport.interactionData["userData"] = window._genesys.widgets.webchat.userData;

      return {
        "form": {
          "autoSubmit": true,
          "firstname":  window._genesys.widgets.webchat.userData.firstName,
          "lastname":  window._genesys.widgets.webchat.userData.lastName,
          "email":  window._genesys.widgets.webchat.userData.email,
        },
        "formJSON": {
          "wrapper": "<table></table>",
          "inputs": [
            {
              "id": "cx_webchat_form_firstname",
              "name": "firstname",
              "maxlength": "100",
              "placeholder": "Required",
              "label": "First Name",
              "value": window._genesys.widgets.webchat.userData.firstName
            },
            {
              "id": "cx_webchat_form_lastname",
              "name": "lastname",
              "maxlength": "100",
              "placeholder": "Required",
              "label": "Last Name",
              "value": window._genesys.widgets.webchat.userData.lastName
            },
            {
              "id": "cx_webchat_form_email",
              "name": "email",
              "maxlength": "100",
              "placeholder": "Required",
              "label": "Email Address",
              "value": window._genesys.widgets.webchat.userData.email
            },
            {
              "id": "cx_webchat_form_member_code",
              "name": "MemberCode",
              "maxlength": "100",
              "placeholder": "Optional",
              "label": "Member Code",
              "value": window._genesys.widgets.webchat.userData.memberCode
            },
            {
              "id": "cx_webchat_form_contact_number",
              "name": "ContactNumber",
              "maxlength": "100",
              "placeholder": "Required",
              "label": "Contact Number",
              "value": window._genesys.widgets.webchat.userData.contactNumber
            }
          ]
        }
      };
    }
    clearChatContent(){
      var x = document.getElementsByClassName("rsc-content");
      x[0].innerHTML = "";
      window._genesys.widgets.webchat.transport.interactionData.routing.skills = [];
      this.setState({ subject:"" });
      // window._genesys.widgets.webchat.userData = {};
    }
    render() {
      const { subject } = this.state;
      if (subject === 'Corporate and SME Plans' || subject === "Partnerships" 
        || subject === 'Corporate Partnership' || subject === 'Sponsorship'|| subject === 'Sponsorships' 
        || subject === 'Events' || subject === 'Promos' || subject === 'Individual and Family' 
        || subject === 'VIP' || subject === 'RxER' || subject ==='Health Plus' || subject === 'Medicard Kabayan' 
        || subject === 'Medicard Select' ||subject === "Medicard Number Inquiry" 
        || subject === "Request approval for Laboratory/Diagnostic test" || subject === "Request approval for Consultation" 
        || subject === "Membership coverage" || subject === "Membership information and utilization" 
        || subject === "Online Consultation" || subject === "Inpatient Inquiry and concerns" 
        || subject === "Dental Coverage and Concern") {
          // this.props.customPlugin && this.props.customPlugin.command('WebChat.close');
          this.props.customPlugin && this.props.customPlugin.command('WebChat.open', this.getAdvancedConfig());

          this.props.setOpened(false)
          this.props.setIsLiveChatinSession(false)
          this.clearChatContent();          

        return( <div style={{display: "none" }}></div>);
      } else {
        return (
        <div>
        </div>
        );
      }
    }
  }

  SpeakWithAgentButton.propTypes = {
    steps: PropTypes.object,
  };
    
  SpeakWithAgentButton.defaultProps = {
    steps: undefined,
  };
